import React, { useState, useEffect } from "react"
import { Col, Form, Row, Tab, Tabs, Button, ButtonGroup } from "react-bootstrap"
import { useNavigate, useLocation } from "react-router-dom"
import {
  capitalizeFirstLetter,
  classificationOptions,
  getBranchId,
  getType,
  selectDropdownStyle,
} from "../../Helpers/Utils/Common"
import { getLowOnStock } from "../../Helpers/apiCalls/Inventory/ItemListApi"
import downloadIcon from "../../Assets/Images/download_icon.png"
import { toastStyle, TokenExpiry } from "../../Helpers/Utils/Common"
import Select from "react-select"
//components
import Navbar from "../../Components/Navbar/Navbar"
import Table from "./Adjustment/AdjustmentTable"
import * as XLSX from "xlsx"

//css
import "./Inventory.css"
import "../../Components/Navbar/Navbar.css"
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches"
import toast from "react-hot-toast"
import { getCategory } from "../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../Helpers/apiCalls/brandsApi"
import Footer from "../../Components/Footer/Footer"
import AdjustmentTableWithDynamicPagination from "../../Components/TableTemplate/AdjustmentTableWithDynamicPagination"

export default function ItemLists() {
  let navigate = useNavigate()
  const { state } = useLocation()

  const userType = getType()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [itemList, setItemList] = useState([])
  const [selectedAction, setSelectedAction] = useState("")
  const [checkedLowStockItems, setCheckedLowStockItems] = useState([])
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  const [excelData, setExcelData] = useState([])
  const xlsxHeaders = ["ITEM", "CUR QTY", "UNIT", "PO", "MIN", "MAX"]

  const [filterConfig, setFilterConfig] = useState({
    branch_id:
      userType === "branch_oic" || userType === "branch_inventory_officer"
        ? getBranchId()
        : "",
    branch_name:
      userType === "branch_oic" || userType === "branch_inventory_officer"
        ? getBranchId()
        : "",
    name: "",
    // item_type: "ingredient",
    with_po: "",
    tab: "",
    shop: "all",
    signed_qty: state ? state.signed_qty : "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const [branches, setBranches] = useState([])

  const [branch, setBranch] = useState({})
  const [branchOptions, setBranchOptions] = useState([])

  function handleOnCheck(row) {
    setCheckedLowStockItems(row.selectedRows)
  }

  function handleViewPO(po_id, shopType) {
    window.open(
      // "purchaseorders/review/1/" + shopType + "/" + shopType + "-" + po_id,
      "purchaseorders/review/1/" + po_id,
      "_blank"
    )
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        value={selectedAction}
        id={row.id}
        onChange={(e) => handleSelectChange(e, row, type)}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="adjust-po" className="color-options">
          Adjust
        </option>
        <option value="history-po" className="color-options">
          History
        </option>
      </Form.Select>
    )
  }

  function OngoingPOBadges(row, type) {
    return (
      <ButtonGroup vertical>
        <>
          {row.ongoing_po?.map((po) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3 p-2"
                onClick={() => handleViewPO(po.id, type)}
                // onClick={() => handleViewContract(row.id, row.payment_mode)}
              >
                {`PO-${po.id}`}
              </button>
              // <Button
              //   className="px-2 py-2 me-1"
              //   variant="outline-warning"
              //   size="sm"
              //   onClick={() => handleViewPO(po.id, type)}
              // >{`PO-${po.id}`}</Button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }

  function handleSelectChange(e, row, type) {
    if (e.target.value === "edit-ps") {
      navigate("/paysuppliers/edit/" + e.target.id + "/" + e.target.role)
    } else if (e.target.value === "adjust-po") {
      navigate("/itemlists/branch-adjustment/" + e.target.id)
    } else if (e.target.value === "history-po") {
      navigate(
        "/itemlists/history/" +
          row.branch_id +
          "/" +
          row.item_id +
          "/" +
          row.item_unit_id +
          "/" +
          row.unit_to_name
      )
    }

    setSelectedAction("")
  }

  async function fetchData() {
    setShowLoader(true)
    setItemList([])
    setTotalItems(0)
    const response = await getLowOnStock(filterConfig)

    if (response.error) {
      TokenExpiry(response)
    } else {
      var items = []
      var sortedData = response.data.data.sort((a, b) =>
        a.item_name > b.item_name ? 1 : b.item_name > a.item_name ? -1 : 0
      )
      sortedData.map(async (PO) => {
        var info = {}

        info.id = PO.id
        info.item_id = PO.item_id
        info.item_unit_id = PO.item_unit_id
        info.branch_id = PO.branch_id
        info.item_name = PO.item_name
        info.current_qty = PO.current_qty
          ? parseInt(PO.current_qty)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.min = PO.min
          ? parseInt(PO.min)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.max = PO.max
          ? parseInt(PO.max)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.ongoing_po_data = PO?.ongoing_po
          ? PO?.ongoing_po
              .map((data) => {
                return `PO-${data.id}`
              })
              .join(", ")
          : ""
        info.critical_level = "1"
        info.unit_to_name = PO.unit_to_name
        info.api_link = ""
        info.item_type = PO.item_type
          ? capitalizeFirstLetter(PO.item_type.replace("_", " "))
          : ""
        info.action = ""
        info.ongoing_po = PO.ongoing_po
        items.push(info)
      })
      setItemList(items)
      setTotalItems(response.data.size)

      var excel = items.map((bill) => {
        var info = {}
        info.item_name = bill.item_name
        info.current_qty = bill.current_qty
        info.unit_to_name = bill.unit_to_name
        info.ongoing_po_data = bill.ongoing_po_data
        info.min = bill.min
        info.max = bill.max
        return info
      })
      setExcelData(excel)
    }
    setShowLoader(false)
  }

  async function fetchAllBranches() {
    setBranches([])
    const response = await getAllBranches()
    if (response.data) {
      var branches = response.data.data.data
        .map((data) => {
          var info = data
          info.label = data.name
          info.value = data.id
          return info
        })
        .filter((data) => {
          return data.is_franchise !== "2"
        })
      if (
        userType === "branch_oic" ||
        userType === "branch_inventory_officer"
      ) {
        var filteredBranch = branches.filter((data) => {
          return data.id === getBranchId()
        })
        setBranches(filteredBranch)
        setFilterConfig((prev) => {
          return {
            ...prev,
            branch_id: filteredBranch[0].value,
            branch_name: filteredBranch[0].label,
            branch_id_value: {
              name: "branch_id",
              label: filteredBranch[0].label,
              value: filteredBranch[0].value,
            },
          }
        })
      } else {
        setBranches(branches)
        setFilterConfig((prev) => {
          return {
            ...prev,
            branch_id: branches[0].value,
            branch_name: branches[0].label,
            branch_id_value: {
              name: "branch_id",
              label: branches[0].label,
              value: branches[0].value,
            },
          }
        })
      }
    }
  }

  function handleBranchChange(e) {
    // setBranch(e);
    // const toFilter = { target: { name: "branch_id", value: e.value } };
    // handleFilterChange(toFilter);
    setFilterConfig((prev) => {
      return {
        ...prev,
        branch_id: e.value,
        branch_name: e.label,
        branch_id_value: {
          name: "branch_id",
          label: e.label,
          value: e.value,
        },
      }
    })
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    console.log(name)

    if (name === "branch_id") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          branch_id: value.split("|")[0],
          branch_name: value.split("|")[1],
        }
      })
    } else {
      setFilterConfig((prev) => {
        return { ...prev, [name]: value }
      })
    }
  }

  const handleCreatePO = () => {
    toast.loading("Preparing your order...", {
      style: toastStyle(),
      duration: 1000,
    })
    navigate("/purchaseorders/add/", {
      state: {
        branch_id: filterConfig.branch_id,
        branch_name: filterConfig.branch_name,
        purchased_items: checkedLowStockItems,
      },
    })
  }

  function renderCreatePOBtn(branch_id) {
    if (branch_id === "1" || branch_id === "2" || branch_id === "5") {
      return (
        <div className="PO-filters">
          <button
            type="button"
            className="button-secondary w-100 p-1"
            onClick={() => handleCreatePO()}
          >
            Create PO
          </button>
        </div>
      )
    } else {
      return null
    }
  }

  const handleTabSelect = (key) => {
    setFilterConfig((prev) => {
      return { ...prev, shop: key }
    })
  }

  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.value = category.id
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
      //subcategories
      var subcategories = response.data.subcategories.map((category) => {
        var info = {}
        info.value = category.subname
        info.label = category.subname
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)
    }
  }

  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "LowOnStock.xlsx", { compression: true })
  }

  useEffect(() => {
    fetchCategories()
    fetchBrands()
    fetchAllBranches()
  }, [])

  useEffect(() => {
    if (filterConfig.branch_id !== "") {
      fetchData()
    }
  }, [filterConfig, currentPage])

  useEffect(() => {
    var subcat = subCategories.filter((data) => {
      return data.category_id === filterConfig?.category_id
    })
    setFilteredSubCategories(subcat)
  }, [filterConfig.category])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WH INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={6}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              LOW ON STOCK{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              className="search-bar"
              placeholder="Search..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            ></input>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row mt-2 mt-lg-0"
          >
            <Select
              className="dropsearch-filter w-100"
              classNamePrefix="react-select"
              value={filterConfig.branch_id_value}
              options={branches}
              onChange={handleBranchChange}
            />
          </Col>
          <Col lg={6}></Col>
          {/* <Col lg={2} className="mt-3 mt-lg-0">
              <div className="PO-filters">
                <button
                    type="button"
                    className="primary-btn"
                    onClick={handleExport}
                >
                    <span className="me-2">
                        <img
                            width={20}
                            height={20}
                            src={downloadIcon} alt=""
                        ></img>
                    </span>
                    Download
                </button>
              </div>
          </Col> */}
          {/* <Col lg={2} className="mt-3 mt-lg-0">
            {renderCreatePOBtn(filterConfig.branch_id)}
          </Col> */}
          {/* {checkedLowStockItems.length !== 0 && (
            <>
              <Col lg={2} className="mt-3 mt-lg-0">
                {renderCreatePOBtn(filterConfig.branch_id)}
              </Col>
            </>
          )} */}
        </Row>

        <div>
          <div className="tab-content">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_category}
                  options={[
                    { label: "All Categories", value: "" },
                    ...categories,
                  ]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        category: e.label,
                        category_id: e.value,
                        selected_category: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Brand"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_brand}
                  options={[{ label: "All Brands", value: "" }, ...brand]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        brand: e.value,
                        selected_brand: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="with_po"
                  className="date-filter force-width w-full"
                  defaultValue={filterConfig.with_po}
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All POs
                  </option>
                  <option value="1">With PO</option>
                  <option value="0">No PO</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="signed_qty"
                  className="date-filter force-width w-full"
                  defaultValue={filterConfig.signed_qty}
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All
                  </option>
                  <option value="positive">Positive</option>
                  <option value="negative">Negative</option>
                </Form.Select>
              </Col>
            </Row>
            <div className="mb-2" />

            <AdjustmentTableWithDynamicPagination
              tableHeaders={["ITEM", "CUR QTY", "UNIT", "PO", "MIN", "MAX"]}
              headerSelector={[
                "item_name",
                "current_qty",
                "unit_to_name",
                "__ongoing_po_badges__",
                "min",
                "max",
              ]}
              tableData={itemList}
              ActionBtn={(row) => ActionBtn(row, "")}
              OngoingPOBadges={(row) => OngoingPOBadges(row, "")}
              showLoader={showLoader}
              tableType="lowOnStock"
              handleOnCheck={(row) => handleOnCheck(row)}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-3" />
          <Row>
            {/* <Col lg={2} className="mt-3 mt-lg-0">
              {renderCreatePOBtn(filterConfig.branch_id)}
            </Col> */}
            {checkedLowStockItems.length !== 0 ? (
              <>
                <Col lg={8} className="mt-3 mt-lg-0"></Col>
                <Col lg={2} className="mt-3 mt-lg-0">
                  {renderCreatePOBtn(filterConfig.branch_id)}
                </Col>
              </>
            ) : (
              <>
                <Col lg={10} className="mt-3 mt-lg-0"></Col>
                {/* <Col lg={8} className="mt-3 mt-lg-0"></Col>
            <Col lg={2} className="mt-3 mt-lg-0">
              {renderCreatePOBtn(filterConfig.branch_id)}
            </Col> */}
                <Col lg={2} className="mt-3 mt-lg-0">
                  <div className="PO-filters">
                    <button
                      type="button"
                      className="primary-btn"
                      onClick={handleExport}
                    >
                      <span className="me-2">
                        <img
                          width={20}
                          height={20}
                          src={downloadIcon}
                          alt=""
                        ></img>
                      </span>
                      Download
                    </button>
                  </div>
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
      <Footer />
    </div>
  )
}
